import React, { useEffect, useRef } from 'react';
import ReactDOM from 'react-dom';
import { FilePond, registerPlugin } from 'react-filepond';
import 'filepond/dist/filepond.min.css';
import FilePondPluginFileValidateSize from 'filepond-plugin-file-validate-size';
import FilePondPluginFileValidateType from 'filepond-plugin-file-validate-type';
import { makeStyles } from '@material-ui/styles';
import CustomLabel from './custom-label';

import { captureException } from '../../services/sentry';

registerPlugin(FilePondPluginFileValidateSize, FilePondPluginFileValidateType);

const useStyles = makeStyles((theme) => ({
  fileUpload: {
    position: 'relative',
    minWidth: '360px',
    '& .filepond--drop-label': {
      minHeight: theme.spacing.unit * 5,
      whiteSpace: 'nowrap'
    }
  }
}));

export default function FileUpload(props) {
  const classes = useStyles();

  const pondContainerRef = useRef();
  const fileRemoveTimeOutRef = useRef([]);

  const pondRef = useRef();

  const onLabelClick = () => {
    pondRef.current.browse();
  };

  const { uploadLabel, disabled } = props;

  useEffect(() => {
    ReactDOM.render(
      <CustomLabel
        onLabelClick={onLabelClick}
        label={uploadLabel}
        disabled={disabled}
      />,
      pondContainerRef.current.querySelector('.filepond--drop-label')
    );

    return function cleanup() {
      fileRemoveTimeOutRef.current.forEach((t) => {
        clearTimeout(t);
      });
    };
  }, [uploadLabel, disabled]);

  const prepareFilePondProps = () => {
    // pass down custom properties for fileupload except default provided by filepond
    // onUpload, uploadLabel, uploadUrl
    const { onUpload, uploadLabel: asUploadLabel, uploadUrl, ...rest } = props;

    const defaultProps = {
      allowMultiple: true,
      server: {
        url: uploadUrl,
        process: {
          ondata: (formData) => {
            const d = new FormData();
            const entries = [...formData.entries()];
            const fileObject = entries.find(
              (e) =>
                e[0] === 'filepond' &&
                typeof e[1] === 'object' &&
                typeof e[1].name === 'string'
            );
            d.append('key', fileObject[1].name);
            d.append('file', fileObject[1]);
            return d;
          }
        }
      },
      onprocessfile: (error, file) => {
        captureException(error);
        if (!error) {
          fileRemoveTimeOutRef.current.push(
            setTimeout(() => pondRef.current.removeFile(file), 3000)
          );
          if (onUpload) {
            onUpload(file);
          }
        }
      },
      allowRevert: false,
      labelInvalidField: 'Please upload a valid file.',
      labelMaxFileSize: 'Maximum allowed file size is {filesize}',
      maxFileSize: '10MB',
      acceptedFileTypes: ['text/csv'],
      fileValidateTypeLabelExpectedTypesMap: { 'text/csv': 'CSV' }
    };

    return { ...defaultProps, ...rest };
  };

  const filePondProps = prepareFilePondProps();

  return (
    <div ref={pondContainerRef}>
      <FilePond
        ref={pondRef}
        {...filePondProps}
        className={classes.fileUpload}
      />
    </div>
  );
}

// export default withStyles(styles)(FileUpload);
